import { BaseFilterInterface } from '../../../shared/interfaces/base-filter.interface';
import { BASE_ROLES } from '../../../core/constants/base-roles';

export const PERMISSION_GROUP_FILTERS: BaseFilterInterface[] = [
  { id: 'all', title: 'user.all', roles: [] },
  { id: 'admin', title: 'permission.isAdmin', roles: [BASE_ROLES.PSP_ADMIN, BASE_ROLES.CUSTOMER_ADMIN] },
];
